import React, { useState } from "react";
import { Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./follow.css";
import axios from "axios";
import API_ENDPOINT from "../wm.api.service";
import Cookies from "universal-cookie";
import { decode } from "base-64";

const cookies = new Cookies();
function Followlistcomponent({ followData, hideModal, view }) {
  const [memberAction, setMemberAction] = useState(
    followData?.following_status
  );
  var token = cookies.get("wmtoken");
  const followAction = (action, profileID) => {
    if (token) {
      if (action === "FOLLOW") {
        setMemberAction(true);
      }
      if (action === "UNFOLLOW") {
        setMemberAction(false);
      }
      var fd = new FormData();
      fd.append("token", decode(token));
      fd.append("identity", "wmhandler");
      fd.append("profile_id", profileID);
      fd.append("action", action);
      axios({
        method: "POST",
        url: `${API_ENDPOINT.apiURL}Profile/followFollowing`,
        data: fd,
      })
        .then(function (response) {
          console.log(response);
        })
        .catch(function (err) {
          console.log(err);
        });
    }
  };

  return (
    <React.Fragment>
      <div className="follow_list mt-3 cursor-pointer relative">
        <Container fluid>
          <Row className="items-center">
            <div className="people_profile_wrapper mr-3">
              <Link to="/" onClick={hideModal}>
                <img
                  src={followData.avatar}
                  alt="follow_img"
                  className="people_profile"
                />
              </Link>
            </div>
            <div className="flex-1">
              <p className="m-0 text-xs lg:text-sm font-semibold">{followData.username}</p>
            </div>
            {view === "FOLLOWERS" ? (
              memberAction === "SELF" ? (
                ""
              ) : memberAction ? (
                <div className="cursor-pointer color-15 capitalize">
                  <button
                    style={{ backgroundColor: "var(--color-5)" }}
                    className="py-1 px-3  text-white rounded-3xl text-xs lg:text-sm"
                    onClick={() => followAction("UNFOLLOW", followData.id)}
                  >
                    Unfollow
                  </button>
                </div>
              ) : (
                <div className="cursor-pointer color-15 capitalize">
                  <button
                    style={{ backgroundColor: "var(--color-5)" }}
                    className="py-1 px-3 bg-blue-400 text-white rounded-3xl text-xs lg:text-sm"
                    onClick={() => followAction("FOLLOW", followData.id)}
                  >
                    Follow
                  </button>
                </div>
              )
            ) : memberAction === "SELF" ? (
              ""
            ) : memberAction ? (
              <div className="cursor-pointer color-15 capitalize">
                <button
                  style={{ backgroundColor: "var(--color-5)" }}
                  className="py-1 px-3 bg-blue-400 text-white rounded-3xl text-xs lg:text-sm"
                  onClick={() => followAction("UNFOLLOW", followData.id)}
                >
                  Unfollow
                </button>
              </div>
            ) : (
              <div className="cursor-pointer color-15 capitalize">
                <button
                  style={{ backgroundColor: "var(--color-5)" }}
                  className="py-1 px-3 bg-blue-400 text-white rounded-3xl text-xs lg:text-sm"
                  onClick={() => followAction("FOLLOW", followData.id)}
                >
                  Follow
                </button>
              </div>
            )}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Followlistcomponent;
